import { useDecision } from '@optimizely/react-sdk'
import { LiveHighlight } from '../liveHighlight'
import { LivePostDetailsProps } from './types'

const LivePostDetails = ({ post, className }: LivePostDetailsProps) => {
  const [{ enabled: enableCommunityWebinar }] = useDecision('com_adm_web_enable_community_webinar')

  if (!enableCommunityWebinar || !post.live) return null

  return (
    <div className={className}>
      <LiveHighlight liveDetail={post.live} permissions={post?.ownerCollectionPermissions} />
    </div>
  )
}

export default LivePostDetails
